export interface TraceEntry {
  traceId: string;
  spanId: string;
}

let activeClickCtx: TraceEntry | null = null;
let endSpanTimer: ReturnType<typeof setTimeout> | null = null;

function generateHex(bytes: number): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
}

export function startClickSpan(_label: string): TraceEntry {
  if (endSpanTimer) {
    clearTimeout(endSpanTimer);
    endSpanTimer = null;
  }
  activeClickCtx = {
    traceId: generateHex(16), // 32-char W3C trace-id
    spanId: generateHex(8),   // 16-char W3C span-id
  };
  // Auto-clear after 2s: captures click-triggered XHRs (<500ms), excludes background polls (30s+)
  endSpanTimer = setTimeout(endClickSpan, 2000);
  return activeClickCtx;
}

export function endClickSpan(): void {
  if (endSpanTimer) {
    clearTimeout(endSpanTimer);
    endSpanTimer = null;
  }
  activeClickCtx = null;
}

export function getActiveClickContext(): TraceEntry | null {
  return activeClickCtx;
}

export function getActiveClickSpanContext(): TraceEntry | null {
  return activeClickCtx;
}
